"use client"

import Link from "next/link";
import { useEffect, useState } from "react";
import { client } from "@/sanity/lib/client";

export function BreakingNewsTicker() {
  const [alert, setAlert] = useState<any>(null);

  useEffect(() => {
    // Single fetch for the global alert
    const query = `*[_type == "siteSettings"][0] {
      breakingNews
    }`;
    client.fetch(query).then((data) => {
      if (data?.breakingNews?.enabled) {
        setAlert(data.breakingNews);
      }
    });
  }, []);

  if (!alert) return null;

  return (
    <div className="bg-brand text-white overflow-hidden py-1 relative border-b border-brand-dark">
      <div className="w-full px-4 md:px-8 flex items-center">
        {/* Live Tag */}
        <div className="flex-shrink-0 flex items-center gap-2 bg-white text-brand px-3 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-widest mr-4 shadow-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-brand animate-pulse" />
          Breaking
        </div>

        {/* The Marquee (Simplified for SSR/UX) */}
        <div className="flex-1 overflow-hidden whitespace-nowrap group">
          <Link href={alert.link || "#"} className="inline-block animate-marquee group-hover:pause italic font-serif text-sm md:text-base font-medium">
            {alert.text} • {alert.text} • {alert.text} • {alert.text}
          </Link>
        </div>

        {/* Close button could be added here, but news sites usually keep it persistence */}
      </div>

      <style jsx>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          display: inline-block;
          animation: marquee 30s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}
